// extracted by mini-css-extract-plugin
export default {"card":"SparePartCard_card__bE2SM","image":"SparePartCard_image__qMJYh","w-530":"SparePartCard_w-530__yKryx","w-426":"SparePartCard_w-426__X-ZUc","h-345":"SparePartCard_h-345__+KE7Y"};